import { render, staticRenderFns } from "./Choicemultiple.vue?vue&type=template&id=425d9290&scoped=true"
import script from "./Choicemultiple.vue?vue&type=script&lang=js"
export * from "./Choicemultiple.vue?vue&type=script&lang=js"
import style0 from "./Choicemultiple.vue?vue&type=style&index=0&id=425d9290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d9290",
  null
  
)

export default component.exports